/**
 * Logger mínimo do frontend — ponto único permitido de `console.*`
 * (CODING_STANDARDS.md, seção 6: `console.log`/`console.error` diretos
 * são proibidos em código de produção fora de um logger dedicado).
 * Espelha o vocabulário do `core/logger/logger.service.ts` da API
 * (`info`/`warn`/`error`), sem reimplementar formatação estruturada em
 * JSON — o console do navegador já cumpre esse papel para depuração
 * local; um sink remoto de log de frontend fica para quando (e se) a
 * necessidade real surgir.
 */
export const logger = {
  info(mensagem: string, contexto?: Record<string, unknown>): void {
    console.info(`[web] ${mensagem}`, contexto ?? '');
  },
  warn(mensagem: string, contexto?: Record<string, unknown>): void {
    console.warn(`[web] ${mensagem}`, contexto ?? '');
  },
  erro(mensagem: string, contexto?: Record<string, unknown>): void {
    console.error(`[web] ${mensagem}`, contexto ?? '');
  },
};
